import { Link } from "react-router-dom";

export default function HeroSection() {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://public.readdy.ai/ai/img_res/3839d507f722bed0eddaf77bd601394b.jpg"
          alt="Professional window cleaning services Northfleet"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0F2040]/85 via-[#0F2040]/70 to-[#0F2040]/40"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 lg:px-10 pt-24 pb-20">
        <div className="max-w-2xl">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 bg-white/15 backdrop-blur-sm border border-white/25 rounded-full px-4 py-2 mb-8">
            <div className="flex gap-0.5">
              {[1,2,3,4,5].map((i) => (
                <i key={i} className="ri-star-fill text-yellow-400 text-xs"></i>
              ))}
            </div>
            <span className="text-white text-sm font-medium">4.9★ Rated on Google · Trusted in Northfleet</span>
          </div>

          {/* Headline */}
          <h1 className="font-heading font-800 text-white leading-tight mb-6" style={{ fontSize: "clamp(2.2rem, 5vw, 3.5rem)", fontWeight: 800 }}>
            Professional Window Cleaning Services{" "}
            <span className="text-[#60AEFF]">You Can Trust</span>
          </h1>

          {/* Subheading */}
          <p className="text-blue-100 text-lg leading-relaxed mb-10 font-body">
            Serving homes and businesses across <strong className="text-white">Northfleet, Gravesend, Kent</strong> and the surrounding areas. Fully insured, experienced, and rated 4.9★ by our happy customers.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-wrap gap-4 mb-14">
            <a
              href="#contact-us"
              className="flex items-center gap-2 bg-[#1E88E5] hover:bg-[#1565C0] text-white font-heading font-semibold text-base px-8 py-4 rounded-lg transition-all cursor-pointer whitespace-nowrap shadow-lg"
            >
              <i className="ri-file-list-3-line"></i>
              Get a Free Quote
            </a>
            <a
              href="tel:02084322244"
              className="flex items-center gap-2 bg-white/15 hover:bg-white/25 backdrop-blur-sm border border-white/40 text-white font-heading font-semibold text-base px-8 py-4 rounded-lg transition-all cursor-pointer whitespace-nowrap"
            >
              <i className="ri-phone-fill text-[#60AEFF]"></i>
              0208 43 222 44
            </a>
          </div>

          {/* Trust Indicators */}
          <div className="flex flex-wrap gap-6">
            {[
              { icon: "ri-shield-check-fill", label: "Fully Insured" },
              { icon: "ri-award-fill", label: "10+ Years Experience" },
              { icon: "ri-map-pin-2-fill", label: "Local Experts" },
            ].map((item) => (
              <div key={item.label} className="flex items-center gap-2 text-blue-100">
                <i className={`${item.icon} text-[#60AEFF] text-base`}></i>
                <span className="font-body text-sm font-medium">{item.label}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 flex flex-col items-center gap-2 text-white/50">
        <span className="text-xs font-body">Scroll Down</span>
        <i className="ri-arrow-down-line animate-bounce"></i>
      </div>
    </section>
  );
}
